<script setup lang="ts">
import { DropdownMenuRoot } from 'reka-ui';
</script>

<template>
    <DropdownMenuRoot>
        <slot />
    </DropdownMenuRoot>
</template>
